import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("session_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const CURRENCY_SYMBOL = { TRY: "₺", USD: "$", EUR: "€", GBP: "£" };

export const fmtMoney = (amount, currency = "TRY") => {
  const sym = CURRENCY_SYMBOL[currency] || "";
  const n = Number(amount || 0).toLocaleString("tr-TR", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${sym}${n}`;
};
